import type { PayoutStatementView, SettlementPart } from '@/api/generated';

/** A settlement's status, from the contract (RETAINED since TMMAPI-0116). */
export type ConsolePayoutStatus = NonNullable<PayoutStatementView['payoutStatus']>;

/** The two outcomes of a month split at deactivation (TMMAPI-0116). */
export interface SplitSettlement {
  retained: SettlementPart;
  normal: SettlementPart;
}

/** The parts of a split settlement, or `null` for any other row (a retained-only row has none). */
export function splitOf(stmt: PayoutStatementView): SplitSettlement | null {
  return stmt.retainedPart && stmt.normalPart
    ? { retained: stmt.retainedPart, normal: stmt.normalPart }
    : null;
}

/** What is payable: a split settlement's normal part, else the row's own. Both are required numbers. */
export function payableOf(stmt: PayoutStatementView): number {
  const split = splitOf(stmt);
  return split ? split.normal.payableMinor : stmt.payableMinor;
}

/** The row carries a retained outcome — whole, or as the retained part of a split. */
export function hasRetained(stmt: PayoutStatementView): boolean {
  return stmt.payoutStatus === 'RETAINED' || splitOf(stmt) !== null;
}
